<style lang="less" scoped>
@import '../../../style/common/variable';
.qyzs{width: 100%;display: flex;flex-direction: column;align-items:center;position: relative;background: #fff;}
.first{width: 1200px;height: 500px;}
.downupbox {img {display: block;}}
.text {width: 1200px;overflow:hidden;background: linear-gradient(to top, #1877CB 0%,#115290 100%);
  .top {width: 100%;height: 48px;;margin: 0px;line-height: 48px;
    .title {margin: 0;color: #fff}
  }
  .bottom {width: 100%;line-height: 16px;height: 60px;
    .content {font-size: 14px;letter-spacing: 1px; overflow: hidden;color: #fff;display: inline-block;margin: 0px 36px;line-height: 19px;text-align: left;text-indent: 2em;}
  }
}
.title{text-align: center;font-size: 25px;}
.second{width: 1200px;height: auto;position: relative;
.gsjs{display: block;text-align: left;}
.video{height: 260px;width: 400px;}
.InfoCard{width: 780px;margin-bottom: 24px;margin-left: 420px;margin-top: -260px;
  .contents{height:150px;overflow: hidden;}}
  .el-button{margin-top: 7px;margin-left: 315px;margin-bottom: -12px;}
}
.button{position:absolute;margin-left: 1100px;margin-top: 15px;color: #666666;}
.third tr{border-bottom: 1px solid red; }
table {border-collapse: collapse;}
table, th, td {border: 1px solid #ECECEC;}
.firsttd, .thirdtd{width: 240px;background-color: #FAFAFA;font-weight: bold;color: #666666;}
.secondtd, .forthtd{width: 360px;}
.third{margin-top:30px;}
.gjda{display: block;text-align: left;}
.tjcp{display: block;text-align: left;display: flex;justify-content: space-between;line-height: 100px;}
.fifth{width: 1200px;margin-top: 10px;position: relative;}
.ryzz{display: block;text-align: left;}
.sixth{width: 1200px;margin-top: 10px;margin-bottom: 40px; position: relative;}
.lxfs{display: block;text-align: left;}
/deep/.video-js .vjs-big-play-button{top: 40%;left: 40%;}
i{font-size: 19px;color: #289FDE;vertical-align: middle;margin-right: 5px;}
h3{line-height: 100px;text-align: left;margin:0;font-size: 18px;}
.el-message-box{width:1100px;}
@media screen and (max-width: @max-screen){
  .qyzs-content{width: 100%;}
  .first{height: auto;}
  .text{width: 100%;}
  .second {
    .video {
      height: auto;
      aspect-ratio: 16/9;
    }
    .InfoCard {
      margin: 10px 0 0 0 !important;
      .contents {
        height: auto;
      }
    }
    .el-button {
      margin-left: 0 !important;
      width: 100%;
    }
  }
}
</style>

<!--李旭 2021.7.6-->
<template>
  <div class="qyzs" :style="screenWidth < 912 ? {'width': screenWidth + 'px'} : ''">
    <div class="downupbox" v-if="!this.curID">
      <img src="static/images/zlkindex/qyzs.png" class="first"  alt="">
      <div class="text" id="text" :style="screenWidth < 912 ? {'width': screenWidth + 'px'} : ''">
        <div class="top">
          <p class="title">该公司暂未在我平台官网注册！</p>
        </div>
      </div>
    </div>
    <div class="qyzs-content" v-if="this.curID">
      <div class="downupbox">
        <div v-if="!QyzsDet[0].bannerthumb">
          <img src="static/images/zlkindex/qyzs.png" class="first"  alt="">
        </div>
        <div v-if="QyzsDet[0].bannerthumb">
          <img :src="QyzsDet[0].bannerthumb" class="first"  alt="">
        </div>
        <div class="text" id="text">
          <div class="top">
            <p class="title">{{QyzsDet[0].company}}</p>
          </div>
          <div class="bottom">
            <span class="content">{{QyzsDet[0].business}}</span>
          </div>
        </div>
      </div>
      <div class="second">
        <div class="gsjs">
          <h3 style="font-size:18px"><i class="iconfont icon-jieshao"></i>公司介绍 / Company profile</h3>
          <div class="video" :style="screenWidth < 912 ? {'width': screenWidth + 'px'} : ''">
            <video-player ref="videoPlayer" :playsinline="true"  :options="playerOptions"></video-player>
          </div>
          <el-card class="InfoCard" :style="screenWidth < 912 ? {'width': screenWidth + 'px'} : ''">
            <div class="contents" v-html="content"></div>
            <el-button  v-if="!show" @click="lookmore">查看更多</el-button>
            <el-button  v-if="show" @click="lookmore">收起</el-button>
          </el-card>
        </div>
      </div>
      <div class="third">
        <div class="gjda">
          <h3 style="font-size:18px"><i class="iconfont icon-ziliaoku"></i>公司档案 / Company files</h3>
        </div>
        <table border >
          <tr style="height:50px">
            <td class="firsttd">公司名称</td>
            <td class="secondtd">{{QyzsDet[0].company}}</td>
            <td class="thirdtd">公司类型</td>
            <td class="forthtd">{{QyzsDet[0].type}}</td>
          </tr>
          <tr style="height:50px">
            <td class="firsttd">所在地</td>
            <td class="secondtd">{{QyzsDet[0].address}}</td>
            <td class="thirdtd">公司规模</td>
            <td class="forthtd">{{QyzsDet[0].size}}</td>
          </tr>
          <tr style="height:50px">
            <td class="firsttd">注册资本</td>
            <td class="secondtd">{{QyzsDet[0].capital}} 万元</td>
            <td class="thirdtd">注册年份</td>
            <td class="forthtd">{{QyzsDet[0].regyear}} 年</td>
          </tr>
          <tr style="height:50px">
            <td class="firsttd">经营范围</td>
            <td class="secondtd" colspan="3">{{QyzsDet[0].business}}</td>
          </tr>
          <tr style="height:50px">
            <td class="firsttd">主营行业</td>
            <td class="secondtd" colspan="3">{{dispc}}</td>
          </tr>
        </table>
      </div>
      <div class="fourth" :style="screenWidth < 912 ? {'width': screenWidth + 'px'} : ''">
        <div class="tjcp">
          <h3 style="font-size:18px"><i class="iconfont icon-chanpin1"></i>推荐产品 / Recommended products</h3>
          <span style="font-weight: 700;cursor: pointer;" @click="loadMore">更多</span>
        </div>
        <div class="recommended">
          <Recommended :cardImgkyxmList="CardImgkyxmList" @clickImgName="clickImgName"></Recommended>
        </div>
      </div>
      <div class="fifth" :style="screenWidth < 912 ? {'width': screenWidth + 'px'} : ''">
        <div class="ryzz">
          <h3><i class="iconfont icon-rongyu"></i>荣誉资质 / Honor</h3>
        </div>
        <div>
          <el-table :data="tableData" style="width: 100%;color:#000000;">
            <el-table-column label="证书图片">
              <template slot-scope="scope">
                <img :src="scope.row.thumb" width="100px" height="80px"/>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="证书名称" align="center" valign="middle" width="180"></el-table-column>
            <el-table-column prop="authority" align="center" valign="middle" label="发证机构"></el-table-column>
            <el-table-column label="发证日期" width="180">
              <template slot-scope="scope">{{ (scope.row.addtime * 1000) | formatTime() }}</template>
            </el-table-column>
            <el-table-column label="到期日期" width="180">
              <template slot-scope="scope">{{ (scope.row.expiretime * 1000) | formatTime() }}</template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="sixth" :style="screenWidth < 912 ? {'width': screenWidth + 'px'} : ''">
        <div class="lxfs">
          <h3 style="font-size:18px"><i class="iconfont icon-fixed-telephone"></i>联系方式 / Contact information</h3>
        </div>
        <div>
          <table border :style="screenWidth < 912 ? {'width': screenWidth + 'px'} : ''">
            <tr style="height:50px">
              <td class="firsttd">公司名称</td>
              <td class="secondtd">{{QyzsDet[0].company}}</td>
              <td class="thirdtd">公司地址</td>
              <td class="forthtd">{{QyzsDet[0].address}}</td>
            </tr>
            <tr style="height:50px">
              <td class="firsttd">所在地区</td>
              <td class="secondtd">{{QyzsDet[0].address}}</td>
              <td class="thirdtd">公司电话</td>
              <td class="forthtd">{{QyzsDet[0].telephone}}</td>
            </tr>
            <tr style="height:50px">
              <td class="firsttd">手机号码</td>
              <td class="secondtd">{{QyzsDet[0].phone}}</td>
              <td class="thirdtd">公司网址</td>
              <td class="forthtd">{{QyzsDet[0].homepage}}</td>
            </tr>
            <tr style="height:50px">
              <td class="firsttd">电子邮件</td>
              <td class="secondtd">{{QyzsDet[0].mail}}</td>
              <td class="thirdtd">联系人</td>
              <td class="forthtd">{{QyzsDet[0].contacts}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Recommended from '../assembly/Recommended'
import playVideo from '../method/playVideo'
import filters from '../method/filter'
export default {
  components:
  {
    Recommended
  },
  mixins: [playVideo, filters],
  data()
  {
    return {
      QyzsDet: [],
      cardImgkyxmList: [],
      content: '',
      tableData: [],
      video: '',
      dispc: '',
      curID: true,
      show: false,
      screenWidth: window.innerWidth
    }
  },
  computed: {
    player()
    {
      return this.$refs.videoPlayer.player
    },
    CardImgkyxmList()
    {
      return this.cardImgkyxmList
    }
  },
  watch:
  {
    $route:
    {
      handler(nval, oval)
      {
        if (+nval.query.id === 0)
          this.curID = false
        else
        {
          this.getQyzsDetails(+nval.query.id)
          this.getProducts(+nval.query.id)
          this.curID = true
        }
      },
      immediate: true
    }
  },
  methods:
  {
    getQyzsDetails(itemid)
    {
      let paras = {cmd: 'query', _major: 11, _minor: 26, _exp: 'id=?', types: 'i', vals: itemid}
      window.post.getPost(paras).then((ret) =>
      {
        let arr = []
        arr.push({
          company: ret[0].company,
          type: ret[0].type,
          business: ret[0].business,
          address: ret[0].address,
          size: ret[0].size,
          capital: ret[0].capital,
          regyear: ret[0].regyear,
          username: ret[0].username,
          telephone: ret[0].telephone,
          mail: ret[0].mail,
          video: ret[0].video,
          bannerthumb: ret[0].bannerthumb,
          contacts: ret[0].contacts,
          phone: ret[0].phone,
          homepage: ret[0].homepage,
          catid: ret[0].catid
        })
        this.QyzsDet = arr
        this.playerOptions.sources[0].src = this.QyzsDet[0].video
        let paras2 = {cmd: 'query', _major: 11, _minor: 47, _exp: 'companyid=?', types: 'i', vals: itemid}
        window.post.getPost(paras2).then(data =>
        {
          let arr1 = []
          data.forEach(item =>
          {
            arr1.push({authority: item.authority, name: item.title, addtime: item.fromtime, expiretime: item.totime, thumb: item.thumb ? item.thumb : 'static/images/moren.jpg'})
          })
          this.tableData = arr1
        })
        let paras5 = {cmd: 'query', _major: 99, _minor: 20, _exp: `id='${ret[0].catid}'`}
        window.post.getPost(paras5).then(data =>
        {
          this.dispc = data[0].dispc
        })
      })
      let paras3 = {cmd: 'query', _major: 11, _minor: 27, _exp: 'id=?', types: 'i', vals: itemid}
      window.post.getPost(paras3).then((rets) =>
      {
        this.content = window.public.decodeContent(rets[0].content)
      })
    },
    getProducts(itemid)
    {
      let paras = {cmd: 'query', _major: 11, _minor: 26, _exp: 'id=?', types: 'i', vals: itemid}
      window.post.getPost(paras).then((ret) =>
      {
        let paras2 = {cmd: 'query', _major: 11, _minor: 14, _exp: `company = '${ret[0].company}'`, orderby: 'id DESC', init: 0, pageno: 1, pagesize: 4}
        window.post.getPost(paras2).then((ret) =>
        {
          let arr = []
          ret[0].data.forEach(item =>
          {
            arr.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', description: '产品名', title: item.title, price: item.price, jiaoyiliang: item.jiaoyiliang, jiaoyijiage: item.jiaoyijiage, company: item.company})
          })
          this.cardImgkyxmList = arr
        })
      })
    },
    /**
     * 选择推荐产品查看详情
     */
    clickImgName(param)
    {
      let url = this.$router.resolve({path: '/HzxmKCPDetails', query: {company: param.company, id: param.id}})
      window.open(url.href, '_blank')
    },
    /**
     * 加载更多
     */
    loadMore()
    {
      let url = this.$router.resolve({path: '/HzxmKCPList'})
      window.open(url.href, '_blank')
    },
    lookmore()
    {
      this.show = !this.show
      if (this.show)
      {
        $('.InfoCard .contents').css('height', 'auto')
        $('.InfoCard .contents').css('min-height', '150px')
      }
      else
        $('.InfoCard .contents').css('height', '150px')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/CompanyShow.vue